export default __webpack_public_path__ + "static/media/art-0-machinery.2368583c.jpeg";